module.exports = __webpack_public_path__ + "img/security1.6ba1275.png";